export default {
  googleToken: 'googleToken',
  password: 'password',
  username: 'username',
  remember: 'remember',
  prestoCardNumber: 'prestoCardNumber',
  verificationNumber: 'verificationNumber',
};
